module.exports = __webpack_public_path__ + "static/media/Montserrat-ExtraLightItalic.d743ecc0.woff";